import request from './utils/request'

export function register(data) { return request.post('/h5/auth/register', data) }
export function login(data) { return request.post('/h5/auth/login', data) }
export function logout() { return request.post('/h5/auth/logout') }
export function getShareConfig() { return request.get('/h5/share/config') }
export function getProfile() { return request.get('/h5/me') }
export function updateAvatar(file) {
  const data = new FormData()
  data.append('file', file)
  return request.post('/h5/me/avatar', data)
}
export function listConsume(params) { return request.get('/h5/consume/list', { params }) }
export function commissionSummary() { return request.get('/h5/commission/summary') }
export function listCommission(params) { return request.get('/h5/commission/list', { params }) }
export function listExchange(params) { return request.get('/h5/exchange/list', { params }) }
export function listPoints(params) { return request.get('/h5/points/list', { params }) }
export function teamCount() { return request.get('/h5/team/count') }
export function listTeam(params) { return request.get('/h5/team/list', { params }) }
export function getAbout() { return request.get('/h5/about') }
export function submitFeedback(data) { return request.post('/h5/feedback', data) }
export function listMyFeedback(params) { return request.get('/h5/feedback/list', { params }) }

export function money(value) {
  const num = Number(value || 0)
  return num.toFixed(2)
}

export function saveAuth(data) {
  localStorage.setItem('h5_token', data.token)
}
